<template>
	<div
		class="file-result"
		@click="download"
		:data-message-id="result.message.id"
	>
		<a class="media-container" :href="media.mediaUrl" download target="_blank">
			<FileIcon
				class="media-icon"
				:icon="media.fileIcon"
				:alt="media.extension"
			/>
			<div class="media-info">
				<div class="media-title" v-safe-html="media.title" data-private />
				<div class="media-details">
					<ProfilePic class="search-profile" :user="user" size="16px" />
					<div class="media-user" v-text="user.fullname" />
					<DotIcon />
					<MessageTime
						:date="result.message.created_at"
						defaultFormat="M/D/YY"
					/>
					<DotIcon />
					<div class="media-size" v-text="media.size" />
				</div>
			</div>
			<div class="media-download">
				<DownloadIcon class="download-icon" type="regular" />
			</div>
		</a>
		<RouterLink class="jump-to-group" @click.stop :to="linkToChat">
			{{ $t('chat_message_viewinchat') }}
		</RouterLink>
		<div v-if="isLoading" class="fetching-wrapper">
			<div class="search-fetching">
				<IosSpinner
					v-if="isLoading"
					background="rgba(255, 255, 255, 0.7)"
					spinnerColor="#4f5053"
					class="connecting-spinner"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { ProfilePic, FileIcon } from '@/components/common'
import MessageTime from '../Message/MessageTime'
import { DownloadIcon, DotIcon } from '@/icons'
import { scrubHighlight, getLinkToChatForMessage } from './searchUtils'
import { getUser } from '@/store'
import IosSpinner from '../IosSpinner'

export default {
	name: 'FileResult',
	components: {
		MessageTime,
		ProfilePic,
		DownloadIcon,
		DotIcon,
		IosSpinner,
		FileIcon,
	},
	props: ['result', 'isLoading'],
	computed: {
		media() {
			const { message, highlight } = this.result
			const media = Object.assign({}, message.media)
			const mediaHighlights = highlight?.messagemedia?.title
			if (mediaHighlights?.length) {
				media.title = scrubHighlight(mediaHighlights[0])
			}
			return media
		},
		user() {
			return getUser(this.result.message.user_id) || {}
		},
		linkToChat() {
			return getLinkToChatForMessage(this.result.message)
		},
	},
	methods: {
		download(e) {
			const { attachment } = this.$refs.mediaView.$refs
			if (attachment === e.target || attachment.contains(e.target)) return
			attachment.click()
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.file-result {
	cursor: pointer;
	display: flex;
	align-items: stretch;
	width: 100%;
	text-decoration: none;
	&:hover {
		.media-download,
		.jump-to-group {
			opacity: 1;
		}
	}
}
.media-container {
	padding: 12px;
	display: flex;
	align-items: center;
	flex-grow: 1;
	text-decoration: none;

	.media-icon {
		font-size: 38px;
	}
	.media-info {
		flex-grow: 1;
		margin-left: 16px;
		.media-title {
			color: #2c2d30;
			margin-bottom: 4px;
		}
		.media-details {
			display: flex;
			align-items: center;
			> svg {
				margin: 0 8px;
				:deep(g) {
					fill: #8a8d93;
				}
			}
			> * {
				font-family: 'Avenir-Medium';
				font-size: 12px;
				color: #8a8d93;
			}
			:deep(.message-time) {
				margin-left: 0;
			}
			.media-user {
				margin-left: 4px;
			}
		}
	}
	&:hover {
		.media-download svg {
			:deep(g) {
				fill: var(--teal-300);
			}
		}
	}
}
.media-download {
	display: flex;
	align-items: center;
	padding: 16px;
	opacity: 0;
	.download-icon {
		color: var(--teal-300);
	}
}
.jump-to-group {
	padding: 0 16px;
	display: flex;
	align-items: center;
	color: var(--blue-300);
	font-family: 'Avenir-Medium';
	font-size: 14px;
	cursor: pointer;
	white-space: nowrap;
	border-left: 1px solid #dfdfdf;
	opacity: 0;
	&:hover {
		text-decoration: underline;
	}
}

:deep(.search-highlight) {
	background: rgba(#ffbb00, 0.18);
	font-style: normal;
}

.fetching-wrapper {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	.search-fetching {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(255, 255, 255, 0.7);
		border-radius: 8px;
	}
}
</style>
